<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>工讀生管理</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><span>助學金管理系統</span></li>
          <li><span>工讀生管理</span></li>
          <li><span>聘用資料填寫(學生)</span></li>
        </ol>
      </div>
    </header>
    <div id="tabs-01" class="row">
      <div id="tabs-03" class="row">
        <div class="col-md-12">
          <section class="panel">
            <header class="panel-heading">
              <div class="panel-actions">
                <a href="#" class="panel-action panel-action-toggle" data-panel-toggle></a>
              </div>
              <h2 class="panel-title">查詢條件</h2>
            </header>
            <div class="panel-body" align="right">
              <div align="left">
                查詢時間：
                <select v-model="search.year">
                  <option v-for="item in yearList" :key="item" :value="item">{{item - 1911}}</option>
                </select>
                <select v-model="search.month">
                  <option v-for="item in 12" :key="item" :value="item">{{item}}</option>
                </select>
                <a href="#" @click.prevent="searchSubmit" class="btn-upload btn btn-primary" style="background-color:#337AB7; border-color:#2E6DA4;">查詢</a>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
    <!-- start: page -->
    <div id="tabs-02" class="row">
      <div id="tabs-04" class="row">
        <div class="col-md-12">
          <section class="panel">
            <div class="panel-body">
              <div align="left">
                小計時數 (依查詢條件變動) : {{totalHour}} 小時 (預設只呈現當月份資料)
              </div>
              <div class="s_tenr" align="right">
                <a href="#" @click.prevent="checkedSubmit" class="btn-upload btn btn-primary">審核通過</a>
              </div>
              <table class="table table-no-more table-bordered table-striped mb-none" ref="table">
                <thead>
                  <tr>
                    <th class="text-center" width="3%">
                      <input type="checkbox" ref="allChecked" @change.prevent="allCheckedChange">
                    </th>
                    <th class="text-center" width="3%">筆數</th>
                    <th class="text-center" width="6%">單位</th>
                    <th class="text-center" width="4%">姓名</th>
                    <th class="text-center" width="4%">學號</th>
                    <th class="text-center" width="4%">工讀日期</th>
                    <th class="text-center" width="4%">時間(起)</th>
                    <th class="text-center" width="4%">時間(迄)</th>
                    <th class="text-center" width="3%">時數</th>
                    <th class="text-center" width="15%">工作項目</th>
                    <th class="text-center" width="3%">審核</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in list" :key="index">
                    <td data-title="筆數" class="text-center">
                      <input type="checkbox" v-if="!item.isChecked&&item.workContent" :value="item.id" @change.prevent="checkedChange">
                    </td>
                    <td data-title="筆數" class="text-center">{{index + 1}}</td>
                    <td data-title="申請單位" class="text-center">{{item.deptName}}</td>
                    <td data-title="工讀生姓名" class="text-center">{{item.studentName}}</td>
                    <td data-title="學號" class="text-center">{{item.studentId}}</td>
                    <td data-title="工讀日期" class="text-center">{{item.workDate}}</td>
                    <td data-title="時間(起)" class="text-center">{{item.workStartTime}}</td>
                    <td data-title="時間(迄)" class="text-center">{{item.workEndTime}}</td>
                    <td data-title="時數" class="text-center">
                      {{item.workTotalHour}}
                      <span v-if="item.leaveTotalHour!=''" style="color:red;">(-{{item.leaveTotalHour}})</span>
                    </td>
                    <td data-title="工作項目" class="text-left">{{item.workContent}}</td>
                    <td data-title="審核" class="text-left">{{item.isChecked ? "已審" : "未審"}}</td>
                  </tr>
                </tbody>
              </table>
              
              <div class="row datatables-footer">
                <div class="col-sm-12">
                  <div class="dataTables_paginate" align="center">
                    <tr>
                      <br>
                      <td align="center">
                        <a href="#" @click.prevent="$router.go(-1)" class="btn-upload btn" style="background-color:#337AB7; border-color:#2E6DA4; color:#FFF;">返回</a>
                      </td>
                    </tr>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
    data() {
    return {
      yearList: [],
      maxYear: null,
      maxMonth: null,
      list: [],
      search: {
        year: null,
        month: null
      },
      checkedList: [],
      totalHour:0
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    yearMonth() {
      return this.$route.query.ym;
    }
  },
  mounted() {
    var d = this.nowDate();
    let nowY = d.getFullYear();
    for (let i = nowY; i >= 2019; i--) {
      this.yearList.push(i);
    }
    this.maxYear = nowY;
    this.search.year = nowY;
    let nowM = d.getMonth() + 1;
    let nowD = d.getDate();
    this.maxMonth = nowM;
    this.search.month = nowM;
    if (this.yearMonth) {
      let ym = this.yearMonth.split('/');
      if (ym.length == 2) {
        this.search.year = parseInt(ym[0]) + 1911;
        this.search.month = parseInt(ym[1]);
      }
    }
    this.load();
  },
  methods: {
    load() {
      this.$http
        .get("/api/workstudy/workstudy-record", { params: { id: this.id, year: this.search.year, month: this.search.month } })
        .then(a => {
          this.list = a.body;
          this.totalHour = 0;
          this.list.forEach(item =>{
            this.totalHour += parseFloat(item.workTotalHour);
            if(item.leaveTotalHour){
              this.totalHour -= parseFloat(item.leaveTotalHour);
            }
          });
        });
    },
    searchSubmit() {
      this.load();
    },
    checkedChange(e) {
      let v = $(e.target).val();
      if ($(e.target).prop("checked") == true) {
        this.checkedList.push(v);
      } else {
        $(this.$refs.allChecked).prop("checked", false);
        let i = this.checkedList.indexOf(v);
        if (i > -1) this.checkedList.splice(i, 1);
      }
    },
    allCheckedChange(e) {
      let checkboxList = $(this.$refs.table).find("tbody input[type=checkbox]");
      if ($(e.target).prop("checked") == true) {
        $(checkboxList).prop("checked", true);
        this.checkedList = [];
        this.list.forEach(a => {
          if (a.isChecked == false && a.workContent)
            this.checkedList.push(a.id);
        });
      } else {
        $(checkboxList).prop("checked", false);
        this.checkedList = [];
      }
    },
    checkedSubmit() {
      if (this.checkedList.length < 1) {
        alert("尚未選取任何資料");
        return false;
      }
      if (!confirm("是否確認審核通過？")) return false;
      this.$http.post("/api/workstudy/work-record-checked", this.checkedList).then(a => {
        if (a.body.status) {
          alert("儲存成功");
          $(this.$refs.allChecked).prop("checked", false);
          this.load();
        } else {
          alert(a.body.msg);
          console.log(a.body.exstr);
        }
      });
    }
  }
};
</script>

<style>
</style>